export const provinceData = [
  'Ilocos Norte',
  'Ilocos Sur',
  'La Union',
  'Pangasinan',
  'Batanes',
  'Cagayan',
  'Isabela',
  'Nueva Vizcaya',
  'Quirino',
  'Bataan',
  'Bulacan',
  'Nueva Ecija',
  'Pampanga',
  'Tarlac',
  'Zambales',
  'Aurora',
  'Batangas',
  'Cavite',
  'Laguna',
  'Quezon',
  'Rizal',
  'Marinduque',
  'Occidental Mindoro',
  'Oriental Mindoro',
  'Palawan',
  'Romblon',
  'Albay',
  'Camarines Norte',
  'Camarines Sur',
  'Catanduanes',
  'Masbate',
  'Sorsogon',
  'Aklan',
  'Antique',
  'Capiz',
  'Iloilo',
  'Negros Occidental',
  'Guimaras',
  'Bohol',
  'Cebu',
  'Negros Oriental',
  'Siquijor',
  'Eastern Samar',
  'Leyte',
  'Northern Samar',
  'Samar (Western Samar)',
  'Southern Leyte',
  'Biliran',
  'Zamboanga Del Norte',
  'Zamboanga Del Sur',
  'Zamboanga Sibugay',
  'Bukidnon',
  'Camiguin',
  'Lanao Del Norte',
  'Misamis Occidental',
  'Misamis Oriental',
  'Davao Del Norte',
  'Davao Del Sur',
  'Davao Oriental',
  'Compostela Valley',
  'Davao Occidental',
  'Cotabato (North Cotabato)',
  'South Cotabato',
  'Sultan Kudarat',
  'Sarangani',
  'Cotabato City',
  'Metro Manila',
  'Abra',
  'Benguet',
  'Ifugao',
  'Kalinga',
  'Mountain Province',
  'Apayao',
  'Basilan',
  'Lanao Del Sur',
  'Maguindanao',
  'Sulu',
  'Tawi-tawi',
  'Agusan Del Norte',
  'Agusan Del Sur',
  'Surigao Del Norte',
  'Surigao Del Sur',
  'Dinagat Islands',
];
